import  gql  from 'graphql-tag'

export const assessmentsReport = gql`query AssessmentsReport($startDate: Date, $endDate: Date, $analyst: ID, $office: ID,  $regional: ID) {
    assessmentsReport(startDate: $startDate, endDate: $endDate, analyst: $analyst, office: $office,  regional: $regional) {
        inProcessAssessmentsCount
        finishedAssessmentsCount
    }
  }`;